<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs/>
          <el-form
            :inline="true"
            :model="searchData"
            class="logSearch">
            <el-form-item>
              <el-select
                v-model="searchData.operator_type"
                placeholder="搜索操作类型"
                size="small"
                @change="onSearch"
                filterable
                clearable>
                <el-option
                  :label="type.name"
                  :value="type.id"
                  v-for="type in operatorType"
                  :key="type.id"/>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                align="right"
                placeholder="操作时间范围"
                size="small"
                @change="onSearch"
                :picker-options="pickerOptions"/>
            </el-form-item>
            <el-form-item>
              <el-input
                v-model="searchData.id"
                placeholder="用户crm_id"
                size="small"/>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="onSearch"
                size="small"
                class="onSearch">查询</el-button>
            </el-form-item>
          </el-form>
          <jm-tableList
            url="/index/system/myLog"
            :refresh.sync="refresh"
            :search-data="searchData"
            class="adminList"/>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .logSearch {
    padding: .5em 0;
  }

  .logSearch .el-form-item {
    margin-bottom: 10px;
  }

  .onSearch {
    padding-right: 2.25em;
    padding-left: 2.25em;
  }
</style>
<script>
import jmTableList from '@/components/data/tableList';

export default {
  components: { jmTableList },
  data() {
    return {
      refresh: false,
      operatorType: [],
      dateRange: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > (Date.now() + (3600 * 1000 * 24)) - 8.64e7;
        },
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (3600 * 1000 * 24 * 7));
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (3600 * 1000 * 24 * 30));
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - (3600 * 1000 * 24 * 90));
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      searchData: {
        id: '', // crm_id
        operator_type: '', // 用户名
        add_time_start: '',
        add_time_end: ''
      },
      operator: []
    };
  },
  methods: {
    fetchData() {
      this.$http._get({
        url: '/index/system/myLoginterface'
      })
        .then(({ data }) => {
          this.operatorType = data;
        });
    },
    onSearch() {
      this.refresh = true;
    }
  },
  beforeMount() {
    this.fetchData();
  },
  watch: {
    dateRange(data) {
      let s = data[0];
      let e = data[1];
      this.searchData.add_time_start = s ? `${s.getFullYear()}-${s.getMonth() + 1}-${s.getDate()}` : '';
      this.searchData.add_time_end = e ? `${e.getFullYear()}-${e.getMonth() + 1}-${e.getDate()}` : '';
    }
  }
};
</script>
